module.exports = __webpack_public_path__ + "static/img/fluent-document-pdf-24-regular.a1f7b166.svg";